import { ChangeDetectorRef, Component, ElementRef, Input, NgZone, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import Hls from 'hls.js';
import { QuillEditorComponent } from 'ngx-quill';
import Quill from 'quill';
import { api } from 'src/app/properties/endpoints';
import { DigitalSopService } from 'src/app/services/digital-sop.service';
import videojs from 'video.js';
import 'videojs-markers';

@Component({
  selector: 'app-digital-sop-preview-organism',
  templateUrl: './digital-sop-preview-organism.component.html',
  styleUrls: ['./digital-sop-preview-organism.component.scss']
})
export class DigitalSopPreviewOrganismComponent {
  sopList: any[] = [];
  formData;
  searchText: string = '';
  selectedSOP: any = null;
  hasSearched: boolean = false;
  @ViewChild('videoPlayer') videoPlayerRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('target') target!: ElementRef;
  @ViewChildren('quillEditor') quillEditors!: QueryList<QuillEditorComponent>;
  sopDetailsForm: FormGroup;
  sopStepForm: FormGroup;
  isCreatingNewSop: boolean = false;
  currentSop: any;
  // videoUrl: any;
  stream: string;
  player: any;
  markers = [];
  sopSteps: { stepName: string; startSeconds: number; endSeconds: number, instructions: string }[] = [];
  svgIcon = `<img src="data:image/svg+xml;utf8,
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' fill='green' width='20' height='20'>
    <path d='M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v112H80c-17.7 0-32 14.3-32 32s14.3 32 
    32 32h112v112c0 17.7 14.3 32 32 32s32-14.3 
    32-32V256h112c17.7 0 32-14.3 
    32-32s-14.3-32-32-32H256V80z'/>
  </svg>" style="width: 20px; height: 20px; display: inline-block;" />`
  editorModules = {
    toolbar: {
      container: '#custom-toolbar',
    }
  };
  selectedInstructions: string = '';
  languageControl: FormControl<boolean> = new FormControl(false);
  currentPlayingIndex: number | null = null;
  selectedStepImage: string = '';
  previewStepImages: { [index: number]: string } = {};
  fetchingImage: boolean[] = [];

  constructor(private digitalSopService: DigitalSopService, private snack: MatSnackBar, private sanitizer: DomSanitizer,
    private fb: FormBuilder, private ngZone: NgZone, private cdr: ChangeDetectorRef,) { }
  ngOnInit(): void {
    this.loadSops();
    this.initForm();
  }

  loadSops(): void {
    this.digitalSopService.getSopList().subscribe((items: any) => {
      this.sopList = items;
    })
  }
  onSearchInputChange() {
    this.selectedSOP = null;
    this.formData = null;
    this.selectedStepImage = '';
    this.currentPlayingIndex = null;
    this.selectedInstructions = '';
    this.sopStepForm.setControl('steps', this.fb.array([]));
    if (this.searchText) {
      const query = this.searchText.toLowerCase().trim();
      this.hasSearched = true;
      this.selectedSOP = this.sopList.find(item =>
        (item.name && item.name.toLowerCase() === query) ||
        (item.partNo && item.partNo.toLowerCase() === query) ||
        (item.station && item.station.toLowerCase() === query)
      ) || null;
      if (this.selectedSOP === null) {
        this.formData = null;
      } else {
        this.formData = this.selectedSOP;
        this.fetchSop(this.formData.id);
        this.selectedInstructions = '';
        this.selectedStepImage = '';
        setTimeout(() => {
          this.setupVideo();
        }, 0);
      }
    }
  }
  clearSearch() {
    this.searchText = '';
    this.hasSearched = false;
  }
  private initForm() {
    this.sopDetailsForm = this.fb.group({
      name: [this.formData?.name || '', Validators.required],
      partNo: [this.formData?.partNo || '', Validators.required],
      station: [this.formData?.station || '', Validators.required]
    });
    this.sopStepForm = this.fb.group({
      steps: this.fb.array([])
    });
  }
  fetchSop(id) {
    this.digitalSopService.getSopById(id).subscribe((res: any) => {
      this.currentSop = res;
      this.sopSteps = [];
      if (res.steps?.length > 0) {
        this.sopSteps = res?.steps;
        this.sopSteps.forEach(step => this.addStepToForm(step));
      }
    })
  }
  get steps(): FormArray {
    return this.sopStepForm.get('steps') as FormArray;
  }
  setupVideo() {
    if (this.formData?.hlsPath) {
      const video: HTMLVideoElement = this.target?.nativeElement;
      this.stream = `${api.host}${this.formData.hlsPath}`;
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(this.stream);  // your HLS .m3u8 stream
        hls.attachMedia(video);
        // hls.on(Hls.Events.MANIFEST_PARSED, () => {
        //   video.play();
        // });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.stream;
        // video.addEventListener('loadedmetadata', () => {
        //   video.play();
        // });
      } else {
        console.error('HLS not supported in this browser.');
      }
      this.player = videojs(video, {
        autoplay: false,
        controls: true,
        preload: 'auto'
      });
    }
  }
  addStepToForm(step?: any) {
    const stepGroup = this.fb.group({
      startSeconds: [step?.startSeconds || 0, Validators.required],
      endSeconds: [step?.endSeconds || 0, Validators.required],
      stepName: [step?.stepName || '', Validators.required],
      instructions: [step?.instructions || '', Validators.required]
    });

    this.steps.push(stepGroup);
  }
  formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  ngOnDestroy(): void {
    if (this.player) {
      this.player.dispose();
    }
  }
  playStep(step: any, index: number) {
    const instructions = step.get('instructions')?.value;
    this.selectedInstructions = instructions;
    this.currentPlayingIndex = index;
    const steps = this.steps.controls;
    if (this.player) {
      const playNext = (currentIdx: number) => {
        if (currentIdx >= steps.length) {
          this.player.pause();
          this.ngZone.run(() => {
            this.currentPlayingIndex = currentIdx - 1;
            this.cdr.detectChanges();
          });
          return;
        }

        const currentStep = steps[currentIdx];
        const start = currentStep.value.startSeconds;
        const end = currentStep.value.endSeconds;
        console.log(currentIdx, "sooop")
        const imageUrl = this.currentSop?.steps[currentIdx].imageUrl;
        console.log(imageUrl, "url")
        const language = localStorage.getItem('preferredLanguage');
        this.ngZone.run(() => {
          this.selectedInstructions = currentStep.get('instructions')?.value;
          if (language === 'Tamil') {
            this.changeLanguage(true)
          }
          if (imageUrl) {
            this.fetchingImage[currentIdx] = true;
            this.digitalSopService.getImage(imageUrl).subscribe({
              next: (blob) => {
                const objectUrl = URL.createObjectURL(blob);
                this.previewStepImages[currentIdx] = objectUrl;
                this.selectedStepImage = this.previewStepImages[currentIdx];
                this.fetchingImage[currentIdx] = false;
                console.log(objectUrl, "pppppppppp");
              },
              error: () => {
                console.error('Failed to fetch step image');
                this.fetchingImage[currentIdx] = false;
              }
            });
          }
          this.currentPlayingIndex = currentIdx;
          this.cdr.detectChanges();
        });
        this.player.currentTime(start);
        this.player.play();

        const checkEndTime = () => {
          if (this.player.currentTime() >= end) {
            this.player.off('timeupdate', checkEndTime);
            // playNext(currentIdx + 1);
            this.ngZone.run(() => {
              playNext(currentIdx + 1);
            });
          }
        };

        this.player.off('timeupdate');
        this.player.on('timeupdate', checkEndTime);
      };

      playNext(index);
    }
  }
  insertSVG(svgContent: string, stepIndex: number) {
    const editorComponent = this.quillEditors.toArray()[stepIndex];
    const editor = editorComponent.quillEditor;

    const range = editor.getSelection(true);
    if (range) {
      editor.clipboard.dangerouslyPasteHTML(range.index, svgContent);
      const updatedHTML = editor.root.innerHTML;
      this.steps.at(stepIndex).get('instructions')?.setValue(updatedHTML);
      editor.setSelection(range.index + svgContent.length, 0);

    }
  }
  changeLanguage(isTamil: boolean) {
    this.languageControl.setValue(isTamil);
    const step: any = this.sopSteps[this.currentPlayingIndex];
    const selectedLang = this.languageControl.value ? 'Tamil' : 'English';
    localStorage.setItem('preferredLanguage', selectedLang);
    if (selectedLang === 'Tamil' && step.langInstructions && step.langInstructions['Tamil']) {
      const instruc = this.decodeBase64(step.langInstructions['Tamil']);
      // const instruc = this.decodeBase64( '🔵');
      console.log(instruc, "select");
      const sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(instruc);
      const editorValue = sanitizedHtml as string;
      console.log(sanitizedHtml, "kkkkkkkkk", editorValue)
      this.selectedInstructions = instruc;
    } else if (selectedLang === 'English' && step.instructions) {
      this.selectedInstructions = step.instructions;
    }
  }
  decodeBase64(encodedText: string): string {
    try {
      // const binaryString = atob(encodedText);
      // const bytes = new Uint8Array(binaryString.length);

      // // Convert binary string to byte array
      // for (let i = 0; i < binaryString.length; i++) {
      //   bytes[i] = binaryString.charCodeAt(i);
      // }
      // const decoded = new TextDecoder('utf-8').decode(bytes);
      // return decoded;
      console.log(this.sanitizeSvgDataUrl(encodedText), "text");
      return decodeURIComponent(escape(window.atob(encodedText)));
    } catch (e) {
      console.error('Base64 decoding failed:', e);
      return '';
    }
  }
  sanitizeSvgDataUrl(text: string) {
    return text.replace(/data:image\/svg\+xml;utf8,([\s\S]*?<\/svg>)/g, (match, svg) => {
      const encodedSvg = encodeURIComponent(svg);
      return `data:image/svg+xml;utf8,${encodedSvg}`;
    });
  }

}
